import { GetterTree } from 'vuex';
import { BoardsGroupModel } from '@descomplica/dex-models';

import RootState from '@/store/root_state';
import { BoardsGroupState } from './state';

const getters: GetterTree<BoardsGroupState, RootState> = {
  getBoardsGroupsByCourseId: (state, getters) => (courseId: number) => {
    if (!courseId) return [];

    return Object.values(state.boardsGroups)
      .filter(boardsGroup => boardsGroup.courseId === courseId)
      .map(boardsGroup => new BoardsGroupModel(boardsGroup, getters));
  },
};

export default getters;
